import { useMemo } from 'react';
import { formatarNumero, toNumberBR } from '../../../../../../utils/masks';

import { resolverDescontoTabelaPreco } from '../../../../../../utils/precos/resolvePoliticaPreco';

const round2 = (v) => Number(Number(v || 0).toFixed(2));

export function useItemPrecoDescontoModule({ modoTabelaPreco, novoProduto, profile, operacaoParametros, MovimentoAPI }) {
    const state = useMemo(() => {
        const usaTabelaPreco = !!profile?.parametros?.itens?.usaTabelaPreco;
        const precoBase = Number(novoProduto?.precoBase || 0);
        const precoNegociado = Number(novoProduto?.precoNegociado || 0); // verificar
        const tabelaPreco = novoProduto?.tabelaPreco;

        const ignoraRegraPrecoDesconto =
            novoProduto?.ignoraRegraPrecoDesconto === true ||
            novoProduto?.permitePrecoAbaixoTabela === true ||
            profile?.layout === 'industria';

        const temPrecoReferencia =
            !ignoraRegraPrecoDesconto &&
            usaTabelaPreco &&
            Number(novoProduto?.produtoId || 0) > 0 &&
            Number(novoProduto?.tabelaPrecoId || 0) > 0 &&
            precoBase > 0 &&
            precoNegociado > 0;

        const descontoPercentual = toNumberBR(novoProduto?.descontoPercentual || 0);
        const descontoValor = toNumberBR(novoProduto?.descontoValor || 0);

        const precoMaximoPercentual = Number(tabelaPreco?.percentualMaximoAcrescimo ?? 0);

        const descontoResolvido = resolverDescontoTabelaPreco({
            tabelaPreco: tabelaPreco || {},
            tabelaPrecoItem: novoProduto || {},
            politicasDesconto: [],
            contexto: {
                produtoId: novoProduto?.produtoId,
                tabelaPrecoId: novoProduto?.tabelaPrecoId,
                quantidade: novoProduto?.quantidade,
                operacaoId: operacaoParametros?.operacaoId,
            },
        });

        const descontoMaximoPercentual = toNumberBR(descontoResolvido?.descontoPermitidoPercentual ?? 0);

        let bloqueadoPorPreco = false;
        let bloqueadoPorDesconto = false;
        let mensagemPrecoDesconto = null;

        const quantidade = Number(novoProduto?.quantidade || 0);
        const valorTotal = Number(novoProduto?.valorTotal || 0);

        const precoNegociadoFinal = quantidade > 0 && valorTotal > 0 ? valorTotal / quantidade : precoNegociado;

        const precoMinimoPermitido =
            usaTabelaPreco && precoBase > 0 ? precoBase - (precoBase * descontoMaximoPercentual) / 100 : precoBase;

        const precoMaximoPermitido = usaTabelaPreco && precoBase > 0 ? precoBase + (precoBase * precoMaximoPercentual) / 100 : 0;

        if (temPrecoReferencia && round2(precoNegociadoFinal) < round2(precoMinimoPermitido)) {
            bloqueadoPorPreco = true;

            mensagemPrecoDesconto = {
                key: `preco-final-abaixo-${Date.now()}`,
                texto: `Preço final abaixo do permitido. Mínimo: R$ ${formatarNumero(Number(precoMinimoPermitido).toFixed(2))}.`,
                tipo: 'warning',
                tempo: 6,
                msgPosition: 'top',
            };
        } else if (temPrecoReferencia && precoNegociado > precoMaximoPermitido) {
            bloqueadoPorPreco = true;

            mensagemPrecoDesconto = {
                key: `preco-acima-${Date.now()}`,
                texto: `Preço acima do permitido. Máximo: R$ ${formatarNumero(Number(precoMaximoPermitido).toFixed(2))}.`,
                tipo: 'warning',
                tempo: 6,
                msgPosition: 'top',
            };
        }

        return {
            precoBase,
            precoNegociado,
            precoNegociadoFinal,

            precoMinimoPermitido,
            precoMaximoPermitido,

            descontoPercentual,
            descontoValor,
            descontoMaximoPercentual,

            bloqueadoPorPreco,
            bloqueadoPorDesconto,

            ignoraRegraPrecoDesconto,
            mensagemPrecoDesconto,
        };
    }, [
        novoProduto?.precoBase,
        novoProduto?.preco,
        novoProduto?.valorUnitario,
        novoProduto?.descontoPercentual,
        novoProduto?.descontoValor,
        novoProduto?.descontoMaximoPercentual,
        novoProduto?.limiteDesconto,
        novoProduto?.produtoId,
        novoProduto?.tabelaPrecoId,
        novoProduto?.ignoraRegraPrecoDesconto,
        novoProduto?.permitePrecoAbaixoTabela,
        profile?.parametros?.itens?.usaTabelaPreco,
        operacaoParametros?.descontoMaximoPercentual,
        operacaoParametros?.limiteDesconto,
        novoProduto?.precoNegociado,
        novoProduto?.valorTotal,
        novoProduto?.quantidade,
        novoProduto?.tabelaPreco?.percentualMaximoAcrescimo,
    ]);

    return { state };
}
